import { Button, Card } from "antd";
import "../styles/index.css";
import { useState, useEffect } from "react";
import { AndhraApiService } from "../httpsservice/ApiService";
import { useParams } from "react-router-dom";

const StatusPage = () => {
  const [txndata, setTxndata] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state
  const { txn_id } = useParams();

  useEffect(() => {
    fetchTransactionData();
  }, []);

  const fetchTransactionData = async () => {
    setLoading(true); // Set loading to true when fetching starts
    const queryData = { txn_id: txn_id };
    try {
      const response = await AndhraApiService.fetchTxnDetails(queryData);
      if (response.data && response.success) {
        setTxndata(response.data);
      } else {
        setTxndata(null);
      }
    } catch (error) {
      console.error("Error fetching bill details:", error);
      setTxndata(null);
    } finally {
      setLoading(false); // Set loading to false when fetching is done
    }
  };

  const handelDownload = async () => {
    try {
      const queryData = { txn_id: txn_id };
      const response = await AndhraApiService.downloadInvoice(queryData, {
        responseType: "blob",
      });

      const fileType = "application/pdf";
      if (fileType !== "application/pdf") {
        console.error("⚠️ Invalid response type received:", fileType);
        return;
      }
      const blob = new Blob([response], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `invoice_${txn_id}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("❌ Error downloading file:", error);
    }
  };

  return (
    <>
      <div className="main-wrapper-andhra-pradesh">
        <div className="center-container">
          <div className="center-box-bill">
            <Card
              className="service-number-card"
              cover={
                <div className="payment-status">
                  <div className="logo-main">
                    <img
                      alt="BSES"
                      className="bses-logo"
                      src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/cpdcl_logo.svg"
                    />
                    <img
                      alt="Bank Logo"
                      className="bob-logo"
                      src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/Federal_bank.svg"
                    />
                  </div>
                  {loading ? (
                    <div className="payment-status-logo-name">
                      <p>Loading...</p> {/* Show loading state */}
                    </div>
                  ) : txndata?.STATUS === "SUCCESS" ? (
                    <div className="payment-status-logo-name">
                      <img
                        alt="Success"
                        className="status-icon"
                        src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/Success.svg"
                      />
                      <p className="success-text">Payment Successful!</p>
                    </div>
                  ) : (
                    <div className="payment-status-logo-name">
                      <img
                        alt="Failed"
                        className="status-icon"
                        src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/failed_icon.svg"
                      />
                      <p className="failed-text">Payment Failed!</p>
                    </div>
                  )}
                </div>
              }
            >
              {loading ? (
                <p>Loading transaction details...</p> // Show loading in table area
              ) : (
                <table className="table">
                  <tbody>
                    <tr>
                      <td>Transaction Reference no</td>
                      <td>{txndata?.Transaction_Reference_No || "NA"}</td>
                    </tr>
                    <tr>
                      <td>Transaction Date & Time</td>
                      <td>{txndata?.Transaction_Date_Time || "NA"}</td>
                    </tr>
                    <tr>
                      <td>Service Number</td>
                      <td>{txndata?.Service_Number || "NA"}</td>
                    </tr>
                    <tr>
                      <td>Service Type</td>
                      <td>{txndata?.Service_Type || "NA"}</td>
                    </tr>
                    <tr>
                      <td>Circle Name</td>
                      <td>{txndata?.Circle_Name || "NA"}</td>
                    </tr>
                    <tr>
                      <td>ERO Code</td>
                      <td>{txndata?.ERO_Code || "NA"}</td>
                    </tr>
                    <tr>
                      <td>Arrear Amount</td>
                      <td>
                        Rs.{" "}
                        {txndata?.Arrear_Amount
                          ? parseFloat(txndata.Arrear_Amount).toFixed(2)
                          : "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td>Current Demand</td>
                      <td>
                        Rs.{" "}
                        {txndata?.Current_Demand
                          ? parseFloat(txndata.Current_Demand).toFixed(2)
                          : "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td>ACD Amount</td>
                      <td>
                        Rs.{" "}
                        {txndata?.ACD_Amount
                          ? parseFloat(txndata.ACD_Amount).toFixed(2)
                          : "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td>Reconnection Fees</td>
                      <td>
                        Rs.{" "}
                        {txndata?.Reconnection_Fees
                          ? parseFloat(txndata.Reconnection_Fees).toFixed(2)
                          : "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td>Transaction Amount</td>
                      <td>
                        Rs.{" "}
                        {txndata?.Transaction_Amount
                          ? parseFloat(txndata.Transaction_Amount).toFixed(2)
                          : "0.00"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
              {!loading && (
                <>
                  {txndata?.STATUS === "SUCCESS" ? (
                    <>
                      <Button
                        className="status-btn"
                        size="large"
                        block
                        onClick={handelDownload}
                      >
                        Download Receipt
                      </Button>

                      <Button
                        className="status-btn"
                        size="large"
                        block
                        onClick={() => {
                          window.location.href = "/APCPDCL/Billpay";
                        }}
                        style={{ marginTop: "10px" }}
                      >
                        Make Another Payment
                      </Button>
                    </>
                  ) : (
                    <Button
                      className="status-btn"
                      size="large"
                      block
                      onClick={() => {
                        window.location.href = "/APCPDCL/Billpay";
                      }}
                      style={{ marginTop: "10px" }}
                    >
                      Retry Payment
                    </Button>
                  )}
                </>
              )}
            </Card>
            <div className="poweredby-logo-main">
              <img
                alt="poweredby-logo"
                className="poweredby-logo"
                src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/poweredbyeasebuzz.png"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatusPage;
